import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";

import { isStaff, useCurrentUser } from "@/app/auth";
import { cn } from "@/lib/utils";

type Section = "timeline" | "apps" | "now";

/** Sections of the activity area. */
export function ActivityTabs() {
  const { t } = useTranslation();
  const me = useCurrentUser();
  const { pathname } = useLocation();
  const current: Section =
    pathname === "/activity/apps" ? "apps" : pathname === "/activity/now" ? "now" : "timeline";
  const tabs: { key: Section; to: string }[] = [
    { key: "timeline", to: "/activity" },
    { key: "apps", to: "/activity/apps" },
    ...(isStaff(me) ? [{ key: "now" as const, to: "/activity/now" }] : []),
  ];
  return (
    <nav aria-label={t("nav.activity")} className="-mt-2 mb-5 flex gap-1 overflow-x-auto border-b">
      {tabs.map((tab) => (
        <Link
          key={tab.key}
          to={tab.to}
          aria-current={tab.key === current ? "page" : undefined}
          className={cn(
            "-mb-px border-b-2 px-3 py-2 font-medium whitespace-nowrap transition-colors",
            tab.key === current
              ? "border-primary text-primary"
              : "border-transparent text-muted hover:text-fg",
          )}
        >
          {t(`activity.tabs.${tab.key}`)}
        </Link>
      ))}
    </nav>
  );
}
